import { render, staticRenderFns } from "./detail-file.vue?vue&type=template&id=076c1d75&scoped=true"
import script from "./detail-file.vue?vue&type=script&lang=js"
export * from "./detail-file.vue?vue&type=script&lang=js"
import style0 from "./detail-file.vue?vue&type=style&index=0&id=076c1d75&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076c1d75",
  null
  
)

export default component.exports